import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Container, Paper, Box, TextField, FormControlLabel, Switch, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { useNotification } from '../../context/NotificationContext';
import PageLayout from '../../components/PageLayout';
import { createAuction } from '../../services/auctions';

function StartAuction() {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [auctionName, setAuctionName] = useState('');
    const [isOpen, setIsOpen] = useState(true);
    const [seasons, setSeasons] = useState([]);
    const [selectedSeason, setSelectedSeason] = useState('');
    const notify = useNotification();

    useEffect(() => {
        const fetchSeasons = async () => {
            try {
                const seasonsCollection = collection(db, 'seasons');
                const seasonsSnapshot = await getDocs(seasonsCollection);
                const seasonsList = seasonsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setSeasons(seasonsList);
                if (seasonsList.length > 0) {
                    setSelectedSeason(seasonsList[0].id);
                }
            } catch (err) {
                console.error("Error fetching seasons:", err);
                notify.error('Kon de seizoenen niet laden.');
            }
        };

        fetchSeasons();
    }, [notify]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!user) {
            notify.error('Je moet ingelogd zijn om een veiling te starten.');
            return;
        }

        if (!selectedSeason) {
            notify.error('Selecteer een seizoen.');
            return;
        }

        try {
            await createAuction({
                name: auctionName,
                seasonId: selectedSeason,
                admin: { uid: user.uid, email: user.email, name: user.name },
                isOpen,
            });

            alert(`Veiling '${auctionName}' is succesvol aangemaakt!`);
            navigate('/my-auctions');
        } catch (err) {
            notify.error('Er is een fout opgetreden bij het aanmaken van de veiling.');
            console.error("Error creating auction:", err);
        }
    };

    return (
        <PageLayout>
            <Container component="main" maxWidth="sm">
                <Paper
                    component="form"
                    onSubmit={handleSubmit}
                    elevation={6}
                    sx={{
                        marginTop: 8,
                        padding: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography component="h1" variant="h4" gutterBottom>
                        Start een nieuwe veiling
                    </Typography>
                    <Box sx={{ mt: 2, width: '100%' }}>
                        <TextField
                            label="Naam van de veiling"
                            variant="outlined"
                            fullWidth
                            required
                            value={auctionName}
                            onChange={(e) => setAuctionName(e.target.value)}
                            sx={{ mb: 3 }}
                        />
                        <FormControl fullWidth sx={{ mb: 3 }}>
                            <InputLabel id="season-select-label">Seizoen</InputLabel>
                            <Select
                                labelId="season-select-label"
                                id="season-select"
                                value={selectedSeason}
                                label="Seizoen"
                                onChange={(e) => setSelectedSeason(e.target.value)}
                                required
                            >
                                {seasons.map((season) => (
                                    <MenuItem key={season.id} value={season.id}>
                                        {season.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControlLabel
                            control={<Switch checked={isOpen} onChange={(e) => setIsOpen(e.target.checked)} />}
                            label={isOpen ? "Open veiling (Iedereen kan meedoen)" : "Besloten veiling (Deelnemers hebben goedkeuring nodig)"}
                            sx={{ mb: 3 }}
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            size="large"
                        >
                            Veiling aanmaken
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </PageLayout>
    );
}

export default StartAuction;
